export default {
    home: {
        mag_1:{
            name: "Livret d'accueil",
            url: "/pdf/livret_accueil_202603.pdf"
        },
        mag_2:{
            name: "Manifeste Care",
            url: "https://manifeste-care.groupeastek.com"
        },
        mag_3:{
            name: "Programme RSE",
            url: "https://programme-rse.groupeastek.com/"
        },
        mag_4:{
            name: "Connekt",
            url: "https://connekt.groupeastek.com/"
        },
        apps: [
            {
                name: "Welcome",
                url: "https://welcome.groupeastek.com"
            },
            {
                name: "Sharepoint",
                url: "https://groupeastek365.sharepoint.com/sites/rhinfo"
            },
            {
                name: "FAQ",
                url: "https://groupeastek365.sharepoint.com/sites/rhinfo/SitePages/FAQ.aspx"
            }
        ]
    },
    tools: [
        {
            name: "Helpdesk",
            url: "https://ticketcenter.astek.net"
        },
        {
            name: "Simus",
            url: "https://astekgroup.simus.fr/"
        },
        {
            name: "Webmail",
            url: "https://outlook.office.com/mail/inbox"
        },
        {
            name: "Share",
            url: "https://share.groupeastek.com"
        },
        {
            name: "MySkills",
            url: "https://myskills.groupeastek.com"
        },
        {
            name: "BrandCenter",
            url: "https://groupeastek365.sharepoint.com/sites/BrandCenter/SitePages/CollabHome.aspx"
        },
        {
            name: "ProjectManagementKit",
            url: "https://groupeastek365.sharepoint.com/sites/KitManagementdeProjet"
        },
        {
            name: "EmisysCertifiedMase",
            url: "https://forms.office.com/e/f7GQwG7sB9"
        },
        {
            name: "N2F",
            url: "https://auth.n2f.com"
        }
    ],
    password: {
        url_astek: "https://changemypassword.groupeastek.com/RDWeb/Pages/fr-FR/password.aspx",
        url_intitek: "https://password.intitek.fr"
    },
    shares: [
        {
            name: "Catalogue",
            url: "https://academy.groupeastek.com"
        },
        {
            name: "Meet-up",
            //url: "https://groupeastek365.sharepoint.com/DPO/ServiceLines/SitePages/Accueil.aspx"
            url: "/#/meetup"
        },
        {
            name: "Ineat",
            url: "https://academie.emisys.fr"
        },
        {
            name: "Blog Ineat",
            url: "https://blog.ineat-group.com/"
        },
        {
            name: "Astek Research Lab",
            url: "https://x"
        },
        {
            name: "Propose Ton Meet-Up",
            url: "mailto:meetup@groupeastek.fr?subject=Proposition de meet-up"
        },
        {
            name: "Participe aux forums",
            url: "https://z"
        }
    ],
    cooptation: {
        url: "https://cooptation.groupeastek.com"
    },
    actus: {
        blog: {
            name: "Blog",
            url: "https://blog.groupeastek.com/"
        },
        networks: {
            instagram: "https://www.instagram.com/astek_group/",
            twitter: "https://twitter.com/astekgroup/",
            linkedin: "https://www.linkedin.com/company/astek",
            facebook: "https://web.facebook.com/GroupeAstek/?_rdc=1&_rdr"
        }
    },
    infos: {
        sites: {
            astekjob: {
                fr: "https://astekjob.com/",
                en: "https://astekjob.com/index.php/home/"
            },
            astekgroup: {
                fr: "https://astekgroup.fr/",
                en: "https://astekgroup.fr/?lang=en"
            }
        },
        contacts: {
            street: "77-81ter, rue Marcel Dassault",
            address: "92100 Boulogne-Billancourt",
            email: "contact@groupeastek.fr"
        }
    },
    legalnotice:{
        termsofservice:{
            portail1:"https://www.portail.groupeastek.fr",
            portail2:"https://portail.groupeastek.fr/",
            jgavaldon:"jgavaldon@groupeastek.fr",
            dpo:"dpo@groupeastek.fr"
        },
        hypertextlinks:{
            portail:"https://www.portail.groupeastek.fr",
            contact: "contact@groupeastek.fr",
            astekgroup:"https://www.astekgroup.fr"
        }
    }
}